<template >
  <div class="footerContentText appMakeCenter" >
    <v-row no-gutters>
      <v-col class="pt-12" cols="12" :lg="2" :sm="4" >
        <v-img
          :src="require('@/assets/footer-logo.png')"
          class="footer-logo"
        />
      </v-col>
      <v-col class="pt-12" cols="12" :lg="7" :sm="4">
        <v-row class="pt-3 justify-center">
           <p class="mb-0 text-center text-sm-left white-text" style="font-size: 1.08rem">Subscribe to the Building Safety Journal</p>
        </v-row>
        <v-row justify="center" class="pt-3">
          <v-btn
            color="#29a39b"
            width="240px"
            height="50px"
            style="border-radius: 0px"
            class="white--text"
            target="_blank"
            href="https://www.iccsafe.org/about/periodicals-and-newsroom/subscribe">Subscribe</v-btn>
        </v-row>
      </v-col>
      <v-col class="pt-12 pl-9" cols="12" :lg="3" :sm="4" >
        <p class="mb-0 ml-9 text-center text-sm-left white-text" style="font-size: 1.08rem">Connect With Us</p>
        <p class="text-center text-sm-left">
          <a href="//www.facebook.com/pages/International-Code-Council/122907857740822?ref=ts" class="icon-footer" target="_blank">
            <i class="fa fa-facebook-square" aria-hidden="true"></i>
          </a>
          <a href="//www.linkedin.com/company/31134" class="icon-footer" target="_blank">
            <i class="fa fa-linkedin-square" aria-hidden="true"></i>
          </a>
          <a href="//www.youtube.com/user/ICCMEDIA" class="icon-footer" target="_blank">
            <i class="fa fa-youtube-play" aria-hidden="true"></i>
          </a>
          <a href="//twitter.com/IntlCodeCouncil" class="icon-footer" target="_blank">
            <i class="fa fa-twitter" aria-hidden="true"></i>
          </a>
          <a href="//www.flickr.com/photos/internationalcodecouncil/" class="icon-footer" target="_blank">
            <i class="fa fa-instagram" aria-hidden="true"></i>
          </a>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mt-2 pb-0 text-center text-sm-left">
        <p class="white-text" style="font-size: 1.08rem">ICC Family of Solutions</p>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col class="mt-2 pb-0 pr-5 text-center text-sm-left">
        <a href="https://www.iccsafe.org/">
          <img id="footer-icc-logo" :src="require('@/assets/icc_logo.svg')" />
        </a>
      </v-col>
      <v-col class="mt-2 pb-0 pr-5 text-center text-sm-left">
        <a href="https://www.icc-es.org/" target="_blank" rel="noopener">
          <img id="footer-es-logo" :src="require('@/assets/es_logo.svg')" />
        </a>
      </v-col>
      <v-col class="mt-2 pb-0 pr-5 text-center text-sm-left">
        <a href="https://www.iasonline.org/" target="_blank" rel="noopener">
          <img id="footer-ias-logo" :src="require('@/assets/ias_logo.svg')" />
        </a>
      </v-col>
      <v-col class="mt-2 pb-0 pr-5 text-center text-sm-left">
        <a href="https://www.generalcode.com/" target="_blank" rel="noopener">
          <img id="footer-gc-logo" :src="require('@/assets/gc_logo.svg')" />
        </a>
      </v-col>
      <v-col class="mt-2 pb-0 pr-5 text-center text-sm-left">
        <a href="https://skghoshassociates.com/" target="_blank" rel="noopener">
          <img id="footer-skga-logo" :src="require('@/assets/skga_logo.svg')" />
        </a>
      </v-col>
      <v-col class="mt-2 pb-0 pr-5 text-center text-sm-left">
        <a href="http://www.resilientalliance.org/" target="_blank" rel="noopener">
          <img class="pt-2" id="footer-ancr-logo" :src="require('@/assets/alliance_logo.svg')" />
        </a>
      </v-col>
      <v-col cols="auto" class="mt-2 pb-0 pr-5 text-center text-sm-left">
        <a href="https://www.icc-nta.org/" target="_blank" rel="noopener">
          <img id="footer-nta-logo" :src="require('@/assets/NTA_WHT.svg')" />
        </a>
      </v-col>
      <v-col  class="mt-2 pb-0 pr-5 text-center text-sm-left">
        <a href="https://www.iccsafe.org/products-and-services/icc-community-development-solutions/" target="_blank" rel="noopener" class="mr-0">
          <img id="footer-cds-logo" :src="require('@/assets/cds_logo.png')" />
        </a>
      </v-col>
      <v-col class="mt-2 pb-0 text-center text-sm-left">
        <a href="https://www.amlegal.com/" target="_blank" rel="noopener" class="mr-0">
          <img id="footer-alp-logo" :src="require('@/assets/ALP_LGO.svg')" />
        </a>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="auto">
        <v-row>
          <v-col cols="auto">
            <a href="https://www.iccsafe.org/about/icc-online-privacy-policy/" class="footer-link">Privacy Policy</a>
          </v-col>
          <v-col cols="auto">
            <span style="font-size: 25px">|</span>
          </v-col>
          <v-col cols="auto">
            <a href="https://www.iccsafe.org/about/terms-of-use/" class="footer-link">Terms of Use</a>
          </v-col>
          <v-col cols="auto">
            <span style="font-size: 25px">|</span>
          </v-col>
          <v-col cols="auto">
            <a href="https://www.iccsafe.org/about/contact-icc/" class="footer-link">Contact Us</a>
          </v-col>
          <v-col cols="auto">
            <span style="font-size: 25px">|</span>
          </v-col>
          <v-col cols="auto">
            <a href="https://www.iccsafe.org/content/accessibility/" class="footer-link">Accessibility Policy</a>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 text-center text-sm-left copyright" :lg="12" :sm="12">
        COPYRIGHT © {{ new Date().getFullYear() }} INTERNATIONAL CODE COUNCIL, INC. ALL RIGHTS RESERVED.
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 text-center text-sm-left copyright" :lg="12" :sm="12">
        Includes copyrighted material of Insurance Services Office, Inc. (ISO) with its permission.  You must obtain advance written permission of the copyright owner prior to any use of the material.  ISO does not guarantee the accuracy or timeliness of the ISO information provided.  ISO shall not be liable for any loss or damage of any kind and howsoever caused resulting from any use of the ISO information.
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'FooterContent',
  data: () => ({
    seen: true
  })
}
</script>
